import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'
import { CurrentSubView } from '../../../models/enums'
import ParameterButton from './ParameterButton'

interface HistoryButtonProps {
  handleBack?: () => void
}

const HistoryButton = ({ handleBack }: HistoryButtonProps): JSX.Element => {
  const dispatch = useDispatch()
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)
  const currentSubView = useSelector((state: RootState) => state.utilsReducer.currentSubView)

  const handleClick = (): void => {
    handleBack?.()
    dispatch(storeActions.utils.setCurrentSubView(currentSubView === CurrentSubView.history ? CurrentSubView.none : CurrentSubView.history))
  }

  return <ParameterButton title={translation.history.title} icon='history' color={currentSubView === CurrentSubView.history ? themeColors.secondary : '#A4A7AF'} onClick={handleClick} />
}

export default HistoryButton
